import styled from 'styled-components';

export const BtnCategorias = styled.div`
    margin: 20px 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
        line-height: 40px;
        margin-bottom: 0px;
    }
`;

export const Buscador = styled.div`
    margin: 20px 0;

    input {
        padding: 19px;
        border-radius: 0;
    }

    button {
        padding: 11px 9px 7px;
        border: 1px solid silver;
        border-radius: 0;
    }
`;
